import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CTAButton } from './CTAButton';
const BOOKS_IMG = 'https://cdn.magicpatterns.com/uploads/bhFSrSEpMQzWKRAtD8S14k/Fotografa_de_producto_de_ultra_Nano_Banana_2_93471.jpg';
export function HeroSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  return <section className="relative overflow-hidden" style={{
    background: 'radial-gradient(ellipse at top center, rgba(212,175,55,0.08) 0%, #0D0D1A 60%, #0A0805 100%)'
  }} data-id="element-123">
      {/* Books background image */}
      <div className="absolute inset-0 bg-center bg-no-repeat bg-cover opacity-[0.18] pointer-events-none" style={{
      backgroundImage: `url(${BOOKS_IMG})`,
      backgroundPosition: 'center 40%',
      maskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)'
    }} data-id="element-124" />

      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-20%,rgba(212,175,55,0.06),transparent_70%)]" data-id="element-125" />

      <motion.div ref={ref} initial={{
      opacity: 0
    }} animate={isInView ? {
      opacity: 1
    } : {
      opacity: 0
    }} transition={{
      duration: 1
    }} className="relative max-w-4xl mx-auto px-6 pt-16 pb-16 md:pt-28 md:pb-24" data-id="element-126">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-heading text-3xl md:text-5xl lg:text-[3.4rem] leading-tight md:leading-tight text-brand-gold text-center font-bold" data-id="element-127">
          ¿Por qué seguís en el mismo lugar aunque lo intentás todos los días?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="font-heading text-lg md:text-xl text-brand-ivory/90 text-center mt-6 italic leading-relaxed max-w-3xl mx-auto" data-id="element-128">
          Porque nadie te dio el sistema completo. Hasta hoy.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-10 space-y-5 text-brand-muted text-base md:text-lg leading-relaxed text-center max-w-2xl mx-auto font-body" data-id="element-129">
          <p data-id="element-130">El problema no es tu esfuerzo.</p>
          <p data-id="element-131">
            El problema es que estás usando piezas sueltas de un sistema que
            solo funciona completo.
          </p>
          <p data-id="element-132">
            Un video de manifestación aquí. Una afirmación allá. Una meditación
            que abandonás a la semana.
          </p>
          <p data-id="element-133">
            <strong className="text-brand-ivory" data-id="element-134">
              Mientras tanto tu subconsciente sigue corriendo el programa viejo
              las 24 horas.
            </strong>
          </p>
          <p className="text-brand-gold font-semibold text-lg md:text-xl" data-id="element-135">
            Hoy eso termina.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 1.1
      }} className="mt-12" data-id="element-136">
          <CTAButton text="→ QUIERO EL SISTEMA COMPLETO AHORA" subtext="Acceso inmediato — Descarga instantánea" data-id="element-137" />
        </motion.div>
      </motion.div>

      <div className="h-px bg-gradient-to-r from-transparent via-brand-gold/40 to-transparent" data-id="element-138" />
    </section>;
}